import ZoomGraphQLReaderNode from './types/zoom-graphql-reader';
import ZoomReaderNode from './types/zoom-reader';
import ZoomWriterNode from './types/zoom-writer';

export const zoomNodes = {
  zoomReader: ZoomReaderNode,
  zoomWriter: ZoomWriterNode,
  zoomGraphQLReader: ZoomGraphQLReaderNode,
};
